import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { RegistrationConfirmationTranslationDictionary } from './registration-confirmation-panel-dictionary.interface';

export const translation: TranslationDictionaryMapping<RegistrationConfirmationTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      SHARED_UI_REGISTRATION_CONFIRMATION_ADDRESS: 'Address',
      SHARED_UI_REGISTRATION_CONFIRMATION_DATE: 'Purchase date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MODEL_NUMBER: 'Model number',
      SHARED_UI_REGISTRATION_CONFIRMATION_SERIAL_NUMBER: 'Serial number',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_WARRANTY: 'Parts guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_AND_LABOUR_WARRANTY:
        'Parts and labour guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_EXTRA_WARRANTY:
        ' + 4 years extra guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PURCHASE_DATE: 'Purchase date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_WARRANTY_LENGTH:
        'Manufacturer warranty length',
      SHARED_UI_REGISTRATION_CONFIRMATION_APPLIANCE: 'Appliance',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_NUMBER: 'Plan number',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_START_DATE: 'Plan Start Date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MONTHLY_PAYMENT: 'Monthly Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_CUSTOMER_DETAILS:
        'Your Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_ADDRESS: 'Address',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_PHONE: 'Phone',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_EMAIL: 'Email',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_TITLE: 'Title',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_NAME: 'Name',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_APPLIANCE: 'Appliance',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_MONTHLY_PAYMENT:
        'Monthly Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_ANNUAL_PAYMENT: 'Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TERMS_AND_CONDITIONS:
        'Appliance Care Plan Terms & Conditions',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TITLE: 'Plan Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_REGISTRATION_DETAILS:
        'Registration Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_APPLIANCE_TYPE:
        'Appliance Type',
      SHARED_UI_REGISTRATION_COPY_YOUR_CODE: 'Copy your code',
    },
    [LocaleId.English_Ireland]: {
      SHARED_UI_REGISTRATION_CONFIRMATION_ADDRESS: 'Address',
      SHARED_UI_REGISTRATION_CONFIRMATION_DATE: 'Purchase date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MODEL_NUMBER: 'Model number',
      SHARED_UI_REGISTRATION_CONFIRMATION_SERIAL_NUMBER: 'Serial number',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_WARRANTY: 'Parts guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_AND_LABOUR_WARRANTY:
        'Parts and labour guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_EXTRA_WARRANTY:
        ' + 4 years extra guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PURCHASE_DATE: 'Purchase date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_WARRANTY_LENGTH:
        'Manufacturer warranty length',
      SHARED_UI_REGISTRATION_CONFIRMATION_APPLIANCE: 'Appliance',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_NUMBER: 'Plan number',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_START_DATE: 'Plan Start Date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MONTHLY_PAYMENT: 'Monthly Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_CUSTOMER_DETAILS:
        'Your Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_ADDRESS: 'Address',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_PHONE: 'Phone',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_EMAIL: 'Email',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_TITLE: 'Title',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_NAME: 'Name',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_APPLIANCE: 'Appliance',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_MONTHLY_PAYMENT:
        'Monthly Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_ANNUAL_PAYMENT: 'Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TERMS_AND_CONDITIONS:
        'Appliance Care Plan Terms & Conditions',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TITLE: 'Plan Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_REGISTRATION_DETAILS:
        'Registration Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_APPLIANCE_TYPE:
        'Appliance Type',
      SHARED_UI_REGISTRATION_COPY_YOUR_CODE: 'Copy your code',
    },
    [LocaleId.English_US]: {
      SHARED_UI_REGISTRATION_CONFIRMATION_ADDRESS: 'Address',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_AND_LABOUR_WARRANTY:
        'Parts and labour guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_WARRANTY_LENGTH:
        'Manufacturer warranty length',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_EXTRA_WARRANTY:
        ' + 4 years extra guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PURCHASE_DATE: 'Purchase date',
      SHARED_UI_REGISTRATION_CONFIRMATION_APPLIANCE: 'Appliance',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_NUMBER: 'Plan number',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_START_DATE: 'Plan Start Date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MONTHLY_PAYMENT: 'Monthly Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_CUSTOMER_DETAILS:
        'Your Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_ADDRESS: 'Address',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_PHONE: 'Phone',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_EMAIL: 'Email',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_TITLE: 'Title',
      SHARED_UI_REGISTRATION_CONFIRMATION_CUSTOMER_DETAILS_NAME: 'Name',
      SHARED_UI_REGISTRATION_CONFIRMATION_DATE: 'Purchase date',
      SHARED_UI_REGISTRATION_CONFIRMATION_MODEL_NUMBER: 'Model number',
      SHARED_UI_REGISTRATION_CONFIRMATION_SERIAL_NUMBER: 'Serial number',
      SHARED_UI_REGISTRATION_CONFIRMATION_PARTS_WARRANTY: 'Parts guarantee',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_APPLIANCE: 'Appliance',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_MONTHLY_PAYMENT:
        'Monthly Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_ANNUAL_PAYMENT: 'Payment',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TERMS_AND_CONDITIONS:
        'Appliance Care Plan Terms & Conditions',
      SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TITLE: 'Plan Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_REGISTRATION_DETAILS:
        'Registration Details',
      SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_APPLIANCE_TYPE:
        'Appliance Type',
      SHARED_UI_REGISTRATION_COPY_YOUR_CODE: 'Copy your code',
    },
  };
